import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import axios from "axios";
import confetti from "canvas-confetti";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// 👑 Monday map salute — fireworks + banner when a fresh WALK CHAMP is crowned.
export const ChampSalute = () => {
  const [champ, setChamp] = useState(null);

  const dismiss = (c) => {
    try { localStorage.setItem("airpog_champ_salute", c.week_of); } catch { /* ignore */ }
    setChamp(null);
  };

  useEffect(() => {
    let t1, t2, t3;
    axios.get(`${API}/pogwalk/champ-banner`).then((r) => {
      const c = r.data.champ;
      if (!c) return;
      let seen = "";
      try { seen = localStorage.getItem("airpog_champ_salute") || ""; } catch { /* ignore */ }
      if (seen === c.week_of) return;
      setChamp(c);
      const burst = (x) => confetti({ particleCount: 70, spread: 75, origin: { x, y: 0.35 }, zIndex: 2000 });
      burst(0.3);
      t1 = setTimeout(() => burst(0.7), 500);
      t2 = setTimeout(() => burst(0.5), 1000);
      t3 = setTimeout(() => dismiss(c), 12000);
    }).catch(() => {});
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  return (
    <AnimatePresence>
      {champ && (
        <motion.div
          data-testid="champ-salute"
          initial={{ opacity: 0, y: -30, scale: 0.9 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: -20 }}
          className="fixed top-24 inset-x-0 z-[1600] flex justify-center pointer-events-none px-4"
        >
          <button data-testid="champ-salute-dismiss" onClick={() => dismiss(champ)}
            className="pointer-events-auto glass-strong border border-amber-400/50 rounded-2xl px-5 py-3 text-center shadow-[0_0_30px_rgba(245,158,11,0.35)]">
            <p className="font-heading font-black text-sm text-amber-300 tracking-widest">👑 NEW WALK CHAMP CROWNED!</p>
            <p className="text-xs font-black text-white mt-0.5">{champ.name} — +{champ.bucks} bucks · {champ.laps} laps · WALK CHAMP shiny ✨</p>
            <p className="text-[9px] font-bold text-slate-400 mt-0.5">tap to salute & dismiss</p>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
